"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalTags = void 0;
const externalTagKeys_1 = require("./externalTagKeys");
var ExternalTags;
(function (ExternalTags) {
    ExternalTags["LAMBDA_COLD_START_TRUE"] = "cold_start:true";
})(ExternalTags = exports.ExternalTags || (exports.ExternalTags = {}));
//# sourceMappingURL=externalTags.js.map